module.exports = __webpack_public_path__ + "img/windtre_bg_login.e59ed858.jpg";